"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CheckingOptinCss = _interopRequireDefault(require("./CheckingOptin.css.js"));

var _radium = _interopRequireDefault(require("radium"));

var _SelectionButton = _interopRequireDefault(require("./SelectionButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CheckingOptin = function CheckingOptin(_ref) {
  var handlers = _ref.handlers;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _CheckingOptinCss.default.mainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-optin-row-1",
    style: _CheckingOptinCss.default['rowBase']
  }, /*#__PURE__*/_react.default.createElement("h2", {
    style: _CheckingOptinCss.default.headerText
  }, /*#__PURE__*/_react.default.createElement("b", null, "Banks are paying $100s"), " to new checking customers.", /*#__PURE__*/_react.default.createElement("br", null), "Would you like to see free checking account options?")), /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-optin-row-2",
    style: _objectSpread({}, _CheckingOptinCss.default['rowBase'], {}, _CheckingOptinCss.default['row2'])
  }, /*#__PURE__*/_react.default.createElement(_SelectionButton.default, {
    button: {
      text: 'Yes',
      color: 'blue'
    },
    handleTheClick: handlers.handleYes
  }), /*#__PURE__*/_react.default.createElement(_SelectionButton.default, {
    button: {
      text: 'No',
      color: 'lightBlue'
    },
    handleTheClick: handlers.handleNo
  })), /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-optin-row-3",
    style: _objectSpread({}, _CheckingOptinCss.default['rowBase'], {}, _CheckingOptinCss.default['row3'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-article-1",
    style: _objectSpread({}, _CheckingOptinCss.default['article'], {}, _CheckingOptinCss.default['content1'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _CheckingOptinCss.default.articleHeading
  }, /*#__PURE__*/_react.default.createElement("b", null, "Why do you need a checking account?")), /*#__PURE__*/_react.default.createElement("div", {
    className: "article-content"
  }, "There are many benefits a checking account can provide.  As technology and security are changing everyday so are checking accounts.  The key is knowing exactly why having a checking account is so important.  Here are just a couple quick tips.")), /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-article-2",
    style: _objectSpread({}, _CheckingOptinCss.default['article'], {}, _CheckingOptinCss.default['content2'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "article-2-subheading",
    style: _CheckingOptinCss.default.subHeading
  }, "Convenience:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Transfer and spend money without the inconvenience carrying cash"), /*#__PURE__*/_react.default.createElement("li", null, "Accounts with a debit card make purchases easy or the ability to withdraw funds at an ATM"), /*#__PURE__*/_react.default.createElement("li", null, "Your paycheck can be directly deposited into your account for faster access to your funds"), /*#__PURE__*/_react.default.createElement("li", null, "Online banking makes it easy to pay your bills without having to write a check"))), /*#__PURE__*/_react.default.createElement("div", {
    key: "checking-article-3",
    style: _objectSpread({}, _CheckingOptinCss.default['article'], {}, _CheckingOptinCss.default['content3'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "article-3-subheading",
    style: _CheckingOptinCss.default.subHeading
  }, "Safety:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Having a debit card or checks are much safer than carrying around cash"), /*#__PURE__*/_react.default.createElement("li", null, "Showing a cancelled check is proof of payment on a bill"), /*#__PURE__*/_react.default.createElement("li", null, "Funds in your checking account are insured up $250,000 per depositor by the FDIC"), /*#__PURE__*/_react.default.createElement("li", null, "Finally, having a personal checking account is a great way to establish and maintain your credit. This is very important when you\u2019re ready for a bigger purchase like an automobile or a home.")))));
};

var _default = (0, _radium.default)(CheckingOptin);

exports.default = _default;

//# sourceMappingURL=CheckingOptin.jsx.map